import { API } from "aws-amplify";
import { createApplication } from "~/graphql/mutations";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";

const EMPTY_APPLICATION: APITypes.Application = {
  id: "",
  status: APITypes.ApplicationStatusType.Submitted,
  startDate: "",
  endDate: "",
  __typename: "Application",
  createdAt: "",
  updatedAt: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  _version: 0,
  _lastChangedAt: 0,
};

export const addApplication = async (
  startDate: string
): Promise<LoaderData<APITypes.Application>> => {
  try {
    const newApplication = await API.graphql({
      query: createApplication,
      variables: {
        input: {
          startDate: startDate,
          status: APITypes.ApplicationStatusType.Submitted,
        },
      },
    });
    return {
      success: true,
      //@ts-ignore
      data: newApplication.data.createApplication,
    };
  } catch (error) {
    console.error("error adding new application", error);
    return {
      success: false,
      data: EMPTY_APPLICATION,
      error,
    };
  }
};
